module.exports = __webpack_public_path__ + "img/gbsinbo_01.396a4d7c.png";